import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const inventoryValuationTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "inventory.valuation-trend",
  name: "Stock value trend",
  description: "Posted inventory asset value at hand, carried forward across quiet days.",
  apps: [
    "home",
    "inventory",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "inventory.stock-value-daily",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "stock_value",
          as: "value",
        },
      ],
      where: {
        type: "condition",
        field: "is_current",
        operator: "eq",
        value: true,
      },
    },
    graphQueries: [
      {
        name: "Stock value at hand",
        query: {
          version: 1,
          source: "inventory.stock-value-daily",
          ...period(30),
          select: [
            {
              type: "field",
              field: "as_of_date",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "sum",
              field: "stock_value",
              as: "value",
            },
          ],
          group_by: [
            {
              field: "as_of_date",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "area",
        color: "#ae3ec9",
        lineWidth: 2,
        fillOpacity: 0.16,
      },
    ],
  },
  inputs: {
    title: "Stock value trend",
    valueFormat: "currency",
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "TZS 0",
    series: [
      0,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
